import SuccessNotification from '../components/blueprintWrappers/SuccessNotification';
import ErrorNotification from '../components/blueprintWrappers/ErrorNotification';
import { Intent } from "@blueprintjs/core";
import NoticeNotifiation from '../components/blueprintWrappers/NoticeNotification';

export const types = {
	SET_DEFAULT: 'GLOBAL_STATE/SET_DEFAULT',
	ADD_SUCCESS: 'GLOBAL_STATE/ADD_SUCCESS',
	ADD_ERROR: 'GLOBAL_STATE/ADD_ERROR',
	ADD_NOTICE: 'GLOBAL_STATE/ADD_NOTICE',
	SET_ATTRIBUTE: 'GLOBAL_STATE/SET_ATTRIBUTE',
	SET_ATTRIBUTE_BY_OBJ: 'GLOBAL_STATE/SET_ATTRIBUTE_BY_OBJ'
}

const defaultState = {
	'pageSaving': false,
	'pageLoading': false,
	'currentOverlay': null
};

export default (state = defaultState, action) => {
	switch(action.type) {
		case types.SET_DEFAULT:
			return defaultState;
		case types.ADD_SUCCESS:
			return state;
		case types.ADD_ERROR:
			return state;
		case types.SET_ATTRIBUTE:
			return Object.assign({}, state, {
				[action.attr]: action.value
			});
		case types.SET_ATTRIBUTE_BY_OBJ:
			return Object.assign({}, state, action.obj);
		default:
			return state;
	}
}

export const actions = {
	setDefault: () => {
		return {type: types.SET_DEFAULT};
	},
	setAttribute: (value, attr) => {
		return {type: types.SET_ATTRIBUTE, value, attr};
	},
	addSuccess: (msg) => {
		SuccessNotification.show({
			message: msg,
			intent: Intent.SUCCESS
		});
		return {
			type: types.ADD_SUCCESS
		}
	},
	addNotice: (msg) => {
		NoticeNotifiation.show({
			message: msg
		})
		return {
			type: types.ADD_NOTICE
		}
	},
	addError: (msg) => {
		ErrorNotification.show({
			message: msg,
			intent: Intent.DANGER
		});
		return {
			type: types.ADD_ERROR
		}
	},
	closeOverlay: () => {
		const obj = {
			currentOverlay: null
		}
		return {
			type:types.SET_ATTRIBUTE_BY_OBJ,
			obj
		}
	},
	openOverlay: (currentOverlay) => {
		const obj = {
			currentOverlay
		}
		return {
			type:types.SET_ATTRIBUTE_BY_OBJ,
			obj
		}
	}
}


// WEBPACK FOOTER //
// ./src/redux/globalState.js